<div class="container-fluid pb-5 adjusted-height">
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <legend data-automation="microsoft-security-groups-header-legend">
      {{ 'tkey;microsoft_360.view.security.groups.membership.header' | translate }}
    </legend>
    <div class="row h-100">
      <div class="col-md-7 order-2 order-md-1 h-100 overflow-auto">
        <ziro-multi-checkbox #securityGroupsCheckboxes [fieldId]="'securityGroups'"></ziro-multi-checkbox>
      </div>
      <div class="col-md-5 order-1 order-md-2 azure-icon">
        <em [ngClass]="ziroIcons.AZURE_LOGO"></em>
      </div>
    </div>
  </ziro-collapsible-section-card>
</div>
